<script lang="ts">
import { classname } from '@/js/utils.js';
import BaseIcon from '@/js/vue/base/base-icon.vue';

const classInfo = classname('hint');

export default {
  name: 'AppHint',
  components: { BaseIcon },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
  },
  methods: {
    classInfo,
  },
};
</script>

<template>
  <div :class="classInfo({ type })">
    <BaseIcon icon="info" :width="20" :height="20" type="main" />
    <slot />
  </div>
</template>

<style lang="scss">
.hint {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;

  &_type {
    &_primary {
      grid-gap: 30px;
      padding: 16px 28px;
      color: #000;
      font-weight: 300;
      font-size: 12px;
      background-color: #e8e8e8;
    }

    &_secondary {
      grid-gap: 8px;
      color: #c4c4c4;
      font-size: 14px;
      line-height: 1.14;
    }
  }
}
</style>
